import {CUSTOMER_TAGS_ENDPOINT} from "../../utils/constants";
import {API_TOKEN} from "../../utils/constants";

const getCountry = () => window.Shopify.country;

const getCustomerID = ({ CustomerId: customerID }) => {
  if (typeof customerID === 'undefined' || customerID === null) {
    throw new Error(`Not a valid ID: ${customerID}`);
  }
  return customerID;
};

const getCustomerTagLabel = ({ Gender: tagValue, SampleOrdered: SampleOrdered }) => {
  if (typeof tagValue === 'undefined' || tagValue === null) {
    throw new Error(`Not a valid value: ${tagValue}`);
  }
  let gender = ''
  switch (tagValue) {
    case 'M':
      gender = 'Consumer Male';
    case 'F':
      gender = 'Consumer Female';
    case 'Carer F':
      gender = 'Carer Female';
    case 'Carer M':
      gender = 'Carer Male';
  }
  // assemble tag array
  const tag = [gender, ...(SampleOrdered ? ["ordered_sample"] : [])];
  return tag;
};

function prepareId(protentialGid) {
  const isRegularIntegerId = (id) => /^\d+$/.test(id)

  const isPositiveInteger = (string) => {
    const number = Number(string)
    const isInteger = Number.isInteger(number)
    const isPositive = number > 0

    return isInteger && isPositive
  }

  const testForGidAndConvert = (gid) => {
    const gidRegex = /gid:\/\/shopify\/Customer\/(\d*)/

    const regexMatches = gid.match(gidRegex)

    const captureGroupOneIsId = 1
    const id = parseInt(regexMatches[captureGroupOneIsId])

    return id
  }

  if (isRegularIntegerId(protentialGid)) {
    return protentialGid
  }

  if (typeof protentialGid === "string" && isPositiveInteger(protentialGid)) {
    return Number(protentialGid)
  }

  if (typeof protentialGid === "string") {
    const id = testForGidAndConvert(protentialGid)

    if (isRegularIntegerId(id)) {
      return id
    }
  }

  throw Error("prepareId: protentialGid input not recognised")
}

const setCustomerProfileTag = async ({ tag, id, country }) => {
  if (!tag && !id && !country) {
    throw new Error(`Not a valid payload`);
  }

  const data = { tag, id: prepareId(id), country };
  const options = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_TOKEN,
    },
  };

  try {
    const request = await fetch(CUSTOMER_TAGS_ENDPOINT, options);
    return request;
  } catch (error) {
    throw new Error(error);
  }
};

export {
  getCountry,
  getCustomerTagLabel,
  getCustomerID,
  setCustomerProfileTag,
};
